<template>
    <span class="renderer phone-simple-renderer">
        <router-link :to="link" v-if="phoneName != ''">
            <span>{{ phoneName }}</span>
        </router-link>
    </span>
</template>

<script>

import Utils from '@/services/utils.js'
import {useDvFlagAccess} from "../../../services/featureFlag";

export default {
    name: 'phonerenderer',
    props: {
        object: {
            type: Object,
            default: null
        }
    },
    computed: {
        phoneName: function () {
            if (this.object.name) {
                return this.object.name;
            }
            return '';
        },
        link() {
            if (useDvFlagAccess("beepiz-licence-can:update")) {
                return '/devices/' + this.object.id
            }
            return ''
        }
    },
}
</script>
